module.exports = __webpack_public_path__ + "img/14.6b1a5df4.svg";